export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const SET_STATUS_MESSAGES = 'SET_STATUS_MESSAGES';

export const NTYPE_DANGER =   'danger';
export const NTYPE_INFO = 'info';
export const NTYPE_WARNING = 'warning';
export const NTYPE_SUCCESS = 'success';

